<div
	class="h-full mt-24px pb-[100px] px-12px custom-filter"
	[formGroup]="filterForm"
>
	<div class="flex justify-between items-center">
		<h1 class="tw-font-bold mb-0 font-semibold text-[24px]">
			{{ 'GENERAL_LABELS.FILTRATION' | translate }}
		</h1>
		<button *ngIf="filterCount" class="flex text-link" (click)="resetFilter()">
			{{ 'ACTIONS.RESET' | translate }}
			<img
				class="align-middle mx-2"
				src="assets/images/icon-reset.svg"
				alt="icon"
			/>
		</button>
	</div>
	<div class="mt-24px">
		<!-- COUNTRIES  -->
		<div class="">
			<p
				class="text-dark-grey text-font-18 ltr:font-DIN-Bold font-bold rtl:font-medium leading-[22px]"
			>
				{{ 'CLIENT.FILTER.COUNTRY' | translate }}
			</p>
			<mat-checkbox
				value="224"
				(change)="countryChange($event, 'selectedCountries')"
				class="ltr:mr-2 rtl:ml-2 mb-[19px] text-font-16 font-Poppins-regular"
				[checked]="getController('selectedCountries')?.value?.includes('224')"
			>
				{{ 'COUNTRIES.EGYPT' | translate }}
			</mat-checkbox>
			<div>
				<mat-checkbox
					(change)="countryChange($event, 'selectedCountries')"
					value="103"
					class="ltr:mr-2 rtl:ml-2 mb-[19px] text-font-16 font-Poppins-regular"
					[checked]="getController('selectedCountries')?.value?.includes('103')"
				>
					{{ 'COUNTRIES.SAUDI_ARABIA' | translate }}
				</mat-checkbox>
			</div>
		</div>
		<!-- SEPARATOR -->
		<div class="w-100 h-[1px] bg-secondry-color-Gray my-24px"></div>
		<!-- REGISTRATION DATE -->
		<p
			class="text-dark-grey text-font-18 ltr:font-DIN-Bold font-bold rtl:font-medium leading-[22px]"
		>
			{{ 'CLIENT.FILTER.REGISTRATION_DATE' | translate }}
		</p>

		<app-custom-datepicker
			[defaultValue]="getController('minDate').value"
			label="GENERAL_LABELS.START_DATE"
			(dateValue)="getController('minDate').setValue($event)"
		></app-custom-datepicker>
		<app-custom-datepicker
			[defaultValue]="getController('maxDate').value"
			label="GENERAL_LABELS.END_DATE"
			(dateValue)="getController('maxDate').setValue($event)"
		></app-custom-datepicker>
		<mat-error>
			<div
				class="whitespace-nowrap"
				*ngIf="
					getController('maxDate').value < getController('minDate').value &&
					getController('maxDate').value
				"
			>
				{{ 'VALIDATION.END_DATE_ERROR' | translate }}
			</div>
		</mat-error>
		<!-- SEPARATOR -->
		<div class="w-100 h-[1px] bg-secondry-color-Gray my-24px"></div>
		<!-- HAS BOOKINGS -->
		<p
			class="text-dark-grey text-font-18 ltr:font-DIN-Bold font-bold rtl:font-medium leading-[22px]"
		>
			{{ 'CLIENT.FILTER.BOOKINGS' | translate }}
		</p>
		<div>
			<mat-checkbox
				formControlName="hasAppointments"
				class="ltr:ml-[11px] rtl:mr-[11px] mb-[19px] text-font-16 font-Poppins-regular"
			>
				{{ 'CLIENT.FILTER.HAVE_BOOKINGS' | translate }}
			</mat-checkbox>
		</div>
		<!-- SEPARATOR -->
		<div class="w-100 h-[1px] bg-secondry-color-Gray my-24px"></div>
		<p
			class="text-dark-grey text-font-18 ltr:font-DIN-Bold font-bold rtl:font-medium leading-[22px]"
		>
			{{ 'CLIENT.FILTER.BOOKING_COUNT' | translate }}
		</p>
		<div>
			<div
				class="flex justify-center items-center mb-24px"
				appearance="outline"
			>
				<mat-form-field class="w-[45%] mb-[30px]" appearance="outline">
					<mat-label> {{ 'CLIENT.FILTER.MINIMUM' | translate }}</mat-label>
					<input
						(wheel)="$event.preventDefault()"
						type="number"
						formControlName="minAppointmentCount"
						matInput
					/>
					<mat-error>
						<validation-message
							[controller]="getController('minAppointmentCount')"
							controller_name="CLIENT.FILTER.MINIMUM"
						>
						</validation-message>
					</mat-error>
				</mat-form-field>
				<span class="mx-[6px] mb-[30px]">-</span>
				<mat-form-field class="w-[45%] mb-[30px]" appearance="outline">
					<mat-label> {{ 'CLIENT.FILTER.MAXIMUM' | translate }}</mat-label>
					<input
						(wheel)="$event.preventDefault()"
						type="number"
						[min]="+filterForm?.get('minAppointmentCount')?.value + 1"
						formControlName="maxAppointmentCount"
						matInput
					/>
					<mat-error>
						<validation-message
							[controller]="getController('maxAppointmentCount')"
							controller_name="CLIENT.FILTER.MAXIMUM"
						>
						</validation-message>
					</mat-error>
				</mat-form-field>
			</div>
		</div>
		<!-- prettier-ignore-attribute -->
		<button
			mat-button
			[disabled]="
				filterCount == 0 ||
				(getController('maxDate').value < getController('minDate').value &&
					getController('maxDate').value 
					) || (getController('maxAppointmentCount').value < getController('minAppointmentCount').value && getController('maxAppointmentCount').value 
					) 
			"
			class="bg-gradient text-white w-[89%] p-0 absolute bottom-5"
			(click)="submit()"
		>
			{{ 'ACTIONS.APPLY_FILTER' | translate }}
		</button>
	</div>
</div>
